 <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div class="grid gap-4">
                        <div>
                        <img class="h-auto max-w-full " src="https://blog.panachecruises.com/sites/default/files/upload/vic-cunard-gala-dinner.jpg?369" alt="">
                        </div>
                        <div>
                        <img class="h-auto max-w-full " src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT77PZXhab7NqFoN6CASLgjAkMkV1EUQ161DsCho-DzZhmuS-ahazHxgc5YY6oy3QJp62o&usqp=CAU" alt="">
                        </div>
                </div>
                <div class="grid gap-4">
                        <div>
                        <img class="h-auto max-w-full " src="https://ik.imgkit.net/3vlqs5axxjf/external/http://images.ntmllc.com/v4/cruise-ship/CUN/CUN010/CUN010_POL_Queen-Elizabeth_ZAB8A9.jpg?tr=w-1200%2Cfo-auto" alt="">
                        </div>
                        <div>
                        <img class="h-auto max-w-full " src="https://www.cunard.com/content/dam/cunard/marketing-assets/ships/queen-anne/venues/queen-anne-panorama-pool-club-15726-mobile.png.image.1008.754.low.png" alt="">
                        </div>
                       
                </div>
                <div class="grid gap-4">
                        <div>
                        <img class="h-auto max-w-full " src="https://paulandcarolelovetotravel.com/wp-content/uploads/2021/10/20210912_195131-01-scaled-e1634324476432.jpeg" alt="">
                        </div>
                        <div>
                        <img class="h-auto max-w-full " src="https://dvzpv6x5302g1.cloudfront.net/AcuCustom/Sitename/DAM/162/CUNARD_Queen_Anne_Grand_Lobby.jpg" alt="">
                        </div>
                       
                </div>
                <div class="grid gap-4">
                        <div>
                        <img class="h-auto max-w-full " src="https://a-us.storyblok.com/f/1005231/3810b579bd/cunard-line_queen-mary-2-qm2-_transatlantic_stern_aaron-saunders_18911728.jpg" alt="">
                        </div>
                        <div>
                        <img class="h-auto max-w-full " src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJXADimGRkXi5TrM9Z4Ah65IQA-h4nRPTdqg&s" alt="">
                        </div>
                        
                </div>
                </div>